/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_FootnoteInputs */

const en_funnel_demo_footnote = /** @type {(inputs: Funnel_Demo_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¹ See also Tversky & Kahneman (1992), pp. 297–323.`)
};

const es_funnel_demo_footnote = /** @type {(inputs: Funnel_Demo_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¹ Véase también Tversky y Kahneman (1992), pp. 297–323.`)
};

/**
* | output |
* | --- |
* | "¹ See also Tversky & Kahneman (1992), pp. 297–323." |
*
* @param {Funnel_Demo_FootnoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_footnote = /** @type {((inputs?: Funnel_Demo_FootnoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_FootnoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_footnote(inputs)
	return en_funnel_demo_footnote(inputs)
});